<div class="desktop-layout">
  <app-menu
    class="menu-column"
    *ngIf="!showDependentsOnly"
    (itemSelected)="selectItem($event)"
  ></app-menu>

  <div *ngIf="isTopicEmpty() && !showDependentsOnly" class="empty-screen">
    <div class="empty-icon">
      <i class="fa-solid fa-diamond"></i>
    </div>
  </div>

  <ng-container *ngIf="(current_topic | async) === 'dashboard'">
    <div class="dashboard-full">
      <dashboard></dashboard>
    </div>
  </ng-container>

  <div
    class="scroll-container"
    [class.move-left]="showDependentsOnly"
    *ngIf="(current_topic | async) !== 'dashboard'"
  >
    <div class="list-column card">
      <ng-container *ngIf="(current_topic | async) === 'branches'">
        <branches></branches>
      </ng-container>
      <ng-container *ngIf="(current_topic | async) === 'users'">
        <users></users>
      </ng-container>
      <ng-container *ngIf="(current_topic | async) === 'departments'">
        <departments></departments>
      </ng-container>
      <ng-container *ngIf="(current_topic | async) === 'priority'">
        <priority></priority>
      </ng-container>
      <ng-container *ngIf="(current_topic | async) === 'status'">
        <status></status>
      </ng-container>
      <ng-container *ngIf="(current_topic | async) === 'tags'">
        <tags></tags>
      </ng-container>
      <ng-container *ngIf="(current_topic | async) === 'tickets'">
        <header-filters
          (filterClicked)="toggleFilterForTicket()"
        ></header-filters>
        <ticket (ticketSelected)="selectTicket($event)"> </ticket>
      </ng-container>
      <ng-container *ngIf="(current_topic | async) === 'multi-action'">
        <multi-action [choiceEvent]="currentChoice"></multi-action>
      </ng-container>
    </div>

    <div class="details-column card">
      <ng-container *ngIf="(current_topic | async) === 'branches'">
        <branch-details></branch-details>
      </ng-container>
      <ng-container *ngIf="(current_topic | async) === 'users'">
        <user-details></user-details>
      </ng-container>
      <ng-container *ngIf="(current_topic | async) === 'departments'">
        <departments-details></departments-details>
      </ng-container>
      <ng-container *ngIf="(current_topic | async) === 'priority'">
        <priority-details></priority-details>
      </ng-container>
      <ng-container *ngIf="(current_topic | async) === 'status'">
        <status-details></status-details>
      </ng-container>
      <ng-container *ngIf="(current_topic | async) === 'tags'">
        <tags-details></tags-details>
      </ng-container>

      <ng-container
        *ngIf="
          (current_topic | async) === 'tickets' &&
          currentNav.action !== 'multi-process'
        "
      >
        <ng-container *ngIf="!showFilterForTicket">
          <ticket-details
            (choiceEvent)="relaySingleChoice($event)"
          ></ticket-details>
        </ng-container>

        <ng-container *ngIf="showFilterForTicket">
          <filter-for-ticket> </filter-for-ticket>
          <header-filters></header-filters>
        </ng-container>
      </ng-container>
      <ng-container
        *ngIf="
          (current_topic | async) === 'tickets' &&
          currentNav.action === 'multi-process'
        "
      >
        <processing></processing>
      </ng-container>
    </div>

    <div class="dependents-column card">
      <ng-container *ngIf="chooseTopic === 'branches'">
        <branches [choiceEvent]="currentChoice"></branches>
      </ng-container>
      <ng-container *ngIf="chooseTopic === 'status'">
        <status [choiceEvent]="currentChoice"></status>
      </ng-container>
      <ng-container *ngIf="chooseTopic === 'priority'">
        <priority [choiceEvent]="currentChoice"></priority>
      </ng-container>
      <ng-container *ngIf="chooseTopic === 'departments'">
        <departments [choiceEvent]="currentChoice"></departments>
      </ng-container>
      <ng-container *ngIf="chooseTopic === 'users'">
        <users [choiceEvent]="currentChoice"></users>
      </ng-container>
      <ng-container *ngIf="chooseTopic === 'multi-action'">
        <multi-action [choiceEvent]="currentChoice"></multi-action>
      </ng-container>
    </div>
  </div>
</div>
